<template>
  <Modal title="课程结算" v-model="visible">
    <Form ref="fundForm" class="form"
          :model="fundParam" :rules="fundRule"
          :label-width="80">
      <Row>
        <Col :span="22">
        <Form-item label="金额" prop="amount">
          <Input v-model.number="fundParam.amount"></Input>
        </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingBalance" @click="balance">确定</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'BalanceModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      openedId: {
        type: Number
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        visible: this.value,
        fundParam: {
          amount: 43.43,
          id: this.openedId
        },
        loadingBalance: false,
        fundRule: {
          amount: [
            {type: 'number', required: true, message: '请输入金额', trigger: 'blur'},
            {type: 'number', message: '必须为数字', trigger: 'blur'}
          ]
        }
      }
    },
    methods: {
      balance () {
        let self = this
        this.loadingAdd = true
        this.$refs.fundForm.validate((valid) => {
          if (!valid) {
            this.$Message.warning('信息输入错误!')
            this.loadingAdd = false
            return
          }
          this.loadingAdd = false
          this.visible = false
          this.$http.post('/bookLesson/balanceBook', {amount: this.fundParam.amount, id: this.openedId}).then(res => {
            console.log(this.openedId)
            self.loadingAdd = false
            if (res) {
              self.successCallback()
              self.$Message.success('处理成功!')
              self.visible = false
              return
            }
          })
        })
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val === true) {
        }
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// BalanceModal.vue?26d23ba9